import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';

/*
  Generated class for the OverdriveProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OverdriveProvider {
  constructor(private api:ApiProvider) {
  }
  async getItemDetailsFromGUID(guid: string) {
    const query = `{
      overdriveItemDetails(itemId:"${guid}"){
        source
        id
        ids { type id }
        title
        author
        format
        imageLinks { url }
        isbns
        subjects
        summaries { text source }
        reviews
      }
    }`;
    let details = await this.api.query(query);
    return details.overdriveItemDetails || null;
  };
  async getSearchResults(term: string, limit: number, offset: number, format: Array<string>, sort: string=null) {
    if(sort === 'RELEVANCE') sort = null;
    const formatString = format ? `["${format}"]` : 'null';
    const sortString = sort ? `"${sort}"` : 'null';
    const query = `{
      overdriveSearch(term: "${term}" formats: ${formatString} limit: ${limit} offset: ${offset} sort: ${sortString}) {
        term start limit total results {
          id
          ids { type id }
          title
          author
          authors
          averageRating
          imageLinks { type url }
          series
          source
        }
      }
    }`;
    const res = await this.api.query(query);
    if(res && res.overdriveSearch && res.overdriveSearch.results) {
      for(let result of res.overdriveSearch.results) result.src = result.source;
    }
    return res.overdriveSearch || null;
  }
  async getFormats() {
    const query = `{
      overdriveFormats {
        name value
      }
    }`;
    const overdriveFormats = await this.api.getData(query, 'overdriveFilters', '1');
    return overdriveFormats || [];
  }
  async getSearchSortTypes() {
    const query = `{
      overdriveSearchSortTypes {
        name type
      }
    }`;
    const overdriveSearchSortTypes = await this.api.getData(query, 'overdriveSearchSortTypes', '1');
    return overdriveSearchSortTypes || [];
  }
}



// WEBPACK FOOTER //
// ./src/providers/overdrive/overdrive.ts